import React, { useEffect } from 'react';
import { Transition } from 'react-transition-group';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';

const propTypes = {
  onScroll: PropTypes.bool,
  trigger: PropTypes.bool,
  delay: PropTypes.number,
  children: PropTypes.any.isRequired,
  threshold: PropTypes.number
};

const AnimateSequence = props => {
  const { children, delay = 0, onScroll = false, trigger = false, threshold = 0 } = props;
  const [ref, inView] = useInView({ threshold: threshold, triggerOnce: true });

  useEffect(() => {
    if (React.Children.toArray(children).length > 1) {
      console.error('Error: Animate item may only have 1 child element');
    }
  }, [children]);

  const renderItems = state => {
    const parent = React.Children.toArray(children)?.[0];
    const childItems = parent?.props?.children;
    const newChildren = childItems.map((item, index) => React.cloneElement(item, { state, index, key: index }));

    return React.cloneElement(parent, { ref, children: newChildren });
  };

  return (
    <Transition in={onScroll ? inView : trigger} timeout={delay} exit={false}>
      {state => renderItems(state)}
    </Transition>
  );
};

AnimateSequence.propTypes = propTypes;

export { AnimateSequence };
